module.exports = __webpack_public_path__ + "img/man-van.64afba36.png";